// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id/steps" endpoint
 */

import chunk from "lodash/chunk";
// eslint-disable-next-line you-dont-need-lodash-underscore/flatten
import flatten from "lodash/flatten";

import type { CanvasStepDocument } from "@dashboardApi/apis/canvas/common";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdSteps } from "./constants";

/**
 * a method to chunk together the requests for a given canvas's steps
 * @note this is needed because of the time it takes to load canvas steps for a given
 *   canvas will sometimes exceed the request timeout.
 */
export const getCanvasVersionStepsChunked = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdSteps,
  (
    signal: AbortSignal,
    appGroupId: string,
    canvasId: string,
    versionId: string,
    stepIds: string[],
    stepsPerRequest?: number
  ): Promise<CanvasStepDocument[]> => {
    const chunkedRequests = chunk(stepIds, stepsPerRequest || 10).map((chunkedIds) => {
      return fetch(
        `/engagement/${appGroupId}/canvas/${canvasId}/versions/${versionId}/steps`,
        "GET",
        {
          step_ids: chunkedIds,
        },
        {
          signal,
        }
      );
    });

    return Promise.all(chunkedRequests).then((responses) => {
      return flatten(responses);
    });
  }
);
